"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Checkable = _interopRequireDefault(require("../Checkable"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _CheckboxButton = require("./CheckboxButton.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The CheckboxButton is used as a toggleable state indicator, as in 'this thing is enabled'.
 * It is currently locked down to use the displayed color theme and will not support others such as a CTA theme.
 */
// intentionally left as a functional component
var CheckboxButton = function CheckboxButton(_ref) {
  var className = _ref.className,
      checked = _ref.checked,
      children = _ref.children,
      dataTestId = _ref.dataTestId,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["className", "checked", "children", "dataTestId", "onClick"]);

  return /*#__PURE__*/_react.default.createElement(_CheckboxButton.StyledCheckboxButton, _extends({
    checked: checked,
    className: className,
    "data-test-id": dataTestId,
    onClick: onClick
  }, props), /*#__PURE__*/_react.default.createElement(_Checkable.default, {
    checked: checked,
    dataTestId: "checkbox-button-checkbox"
  }), /*#__PURE__*/_react.default.createElement(_CheckboxButton.StyledLabel, {
    "data-test-id": "checkbox-button-label"
  }, children));
};

CheckboxButton.propTypes = {
  /** Checked flag */
  checked: _propTypes.default.bool,

  /** children are expected to be any valid dom node or array of dom nodes (or react objects) */
  children: _propTypes2.default.children,

  /** className hook for wrapping dom node */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** standard onClick handler */
  onClick: _propTypes.default.func.isRequired
};
CheckboxButton.defaultProps = {
  className: '',
  checked: false,
  children: ''
};
var _default = CheckboxButton;
exports.default = _default;